<template>
  <div
    class="plan-slot"
    :class="'ruolo_' + Constants.RUOLO[ruolo_abc]"
  >
    <div
      class="ruolo-pos"
      :aria-label="ruolo_abc + ', posizione ' + (i + 1)"
    >
      <span class="ruolo-label">{{ ruolo_abc }}</span>
      <span class="pos">{{ i + 1 }}</span>
    </div>
    <div v-if="associato" class="nomi-calciatori associato">
      <div class="plan-player-info">
        <maglia-or-flag-plus-nome :calciatore="calciatori[associato]" />
        <div>
        <span class="associato-name">{{ nomeCalciatoreAssociato }}</span>
        <span
          v-if="mantra && ruoliMantraAssociato.length"
          class="plan-mantra-roles"
        >
          <ruolo-mantra
            v-for="mantraId in ruoliMantraAssociato"
            :key="mantraId"
            :mantra-id="mantraId"
            small
          />
        </span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <main-status
        v-if="calciatori[associato] && calciatori[associato].ms"
        :ms="calciatori[associato].ms"
        small
        class="flex-shrink-0 mx-1"
      />
      <v-btn
        class="azione-associa associato"
        icon
        x-small
        :disabled="onlyAssociaSlot || readonly"
        @click="disassocia"
        aria-label="Rimuovi calciatore dallo slot"
      >
        <v-icon class="navy--text" small>close</v-icon>
      </v-btn>
    </div>
    <div
      v-else
      class="nomi-calciatori obiettivi-calciatori"
      :class="{ disabled: onlyAssociaSlot || readonly || fuoriLimite }"
      @click="promptAddObiettivo"
    >
      <div class="obiettivi-list">
        <span v-if="obiettiviVisibili.length == 0" class="obiettivi-placeholder">
          Aggiungi obiettivo
        </span>
        <span
          v-for="obiettivo in obiettiviVisibili"
          :key="obiettivo.id"
          class="obiettivo-chip"
          :class="{ 'has-mantra': mantra && obiettivo.mantra_ids.length }"
          @click.stop="removeObiettivo(obiettivo.id)"
        >
          <span class="plan-player-info">
            <span class="obiettivo-name">{{ obiettivo.nome }}</span>
            <span
              v-if="mantra && obiettivo.mantra_ids.length"
              class="plan-mantra-roles"
            >
              <ruolo-mantra
                v-for="mantraId in obiettivo.mantra_ids"
                :key="mantraId"
                :mantra-id="mantraId"
                small
              />
            </span>
          </span>
          <v-btn
            x-small
            icon
            class="obiettivo-remove"
            :disabled="onlyAssociaSlot || readonly || fuoriLimite"
            @click.stop="removeObiettivo(obiettivo.id)"
          >
            <v-icon x-small>close</v-icon>
          </v-btn>
        </span>
      </div>
      <v-btn
        v-if="(acquistiSenzaSlotPerRuolo[ruolo_abc] || []).length > 0"
        class="azione-associa evidenzia"
        icon
        x-small
        :class="{ evidenzia: onlyAssociaSlot }"
        :disabled="readonly || fuoriLimite"
        @click.stop="
          overrideAssociaClick ? overrideAssociaClickCb() : associaCalciatore()
        "
        aria-label="Associa un calciatore allo slot"
      >
        <v-icon class="navy--text" small>add</v-icon>
      </v-btn>
    </div>
    <div v-if="associato" class="crediti-pianificati associato">
      <crediti :crediti="pagato"></crediti>
    </div>
    <v-btn
      v-else
      class="crediti-pianificati"
      @click="showNumpad"
      :disabled="onlyAssociaSlot || readonly || fuoriLimite"
      >{{ pCrediti == 0 ? "..." : pCrediti }}</v-btn
    >
    <div v-if="append">
      <v-icon class="white--text">chevron_right</v-icon>
    </div>
    <div v-if="append" class="new-plan">
      {{ append }}
    </div>
    <v-dialog
      v-model="dialogDisassocia"
      max-width="500"
      :retain-focus="false"
      :persistent="disassociando"
    >
      <v-card class="navy">
        <div class="secondary white--text d-flex align-center font-hemi-head pa-4">
          <span style="font-size: 16px">
            Rimuovi il calciatore acquistato da questo slot
          </span>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            icon
            :disabled="disassociando"
            @click="dialogDisassocia = false"
            aria-label="Chiudi"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="white--text pt-4">
          <p>Rimuovi il calciatore acquistato da questo slot... e poi mettilo in un altro slot premendo sul relativo “+” che ti comparirá.</p>
          <v-alert dense text type="info">
            <div><b>Occhio, il calciatore resterá comunque nella tua rosa!</b></div>
            Se volevi annullare l’assegnazione, clicca su
            <v-btn
              x-small
              outlined
              color="accent"
              :disabled="disassociando"
              @click="showRoseLega"
            >ROSE</v-btn>
            <b> → tre puntini in corrispondenza del calciatore → Rimetti svincolato</b>.
          </v-alert>
          <v-checkbox
            v-model="nonMostrareDisassocia"
            label="Non mostrare più"
            :disabled="disassociando"
            hide-details
            color="secondary"
          />
        </v-card-text>
        <v-card-actions class="flex-wrap justify-end pa-4">
          <v-btn text :disabled="disassociando" @click="dialogDisassocia = false">
            Annulla
          </v-btn>
          <v-btn
            class="secondary"
            :loading="disassociando"
            @click="confermaDisassocia"
          >
            Capito. Rimuovi da questo slot
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "../js/db";

import mixins from "../js/mixins";
import toast from "../js/toast";

import Constants from "../js/constants";

import Vuex from "vuex";
import RuoloMantra from "./common/RuoloMantra";
import Crediti from "./common/Crediti";
import MagliaOrFlagPlusNome from "./common/MagliaOrFlagPlusNome";
import MainStatus from "./common/MainStatus";

export default {
  name: "asta-slot",
  components: { RuoloMantra, Crediti, MagliaOrFlagPlusNome, MainStatus },
  mixins: [mixins, toast],
  data() {
    return {
      pCrediti: null,
      disassociando: false,
      dialogDisassocia: false,
      nonMostrareDisassocia: false,
      associatoDaDisassociare: null,
    };
  },
  props: {
    i: {
      type: Number,
    },
    ruolo_abc: {
      type: String,
      required: true,
    },
    iSlot: {
      type: String,
      required: true,
    },
    onlyAssociaSlot: {
      type: Boolean,
    },
    overrideAssociaClick: {
      type: Function,
    },
    readonly: {
      type: Boolean,
    },
    append: {
      type: Number,
    },
  },
  mounted() {
    console.log("--> AstaSlot mounted.");
  },
  destroyed() {
    console.log("<-- AstaSlot destroyed.");
  },
  methods: {
    showRoseLega() {
      this.dialogDisassocia = false;
      db.emit("showDialogRoseLega");
    },
    associaCalciatore() {
      if (this.readonly || this.fuoriLimite) return;
      db.emit("DialogAssociaCalciatore", this.ruolo_abc, this.iSlot);
    },
    promptAddObiettivo() {
      if (this.onlyAssociaSlot || this.readonly || this.fuoriLimite) {
        return;
      }
      db.emit("DialogPlanObiettivo", this.ruolo_abc, this.iSlot);
    },
    updateObiettivi(ids) {
      return db.updatePlan({
        [this.ruolo_abc]: {
          [this.iSlot]: {
            calciatori: ids.length ? Object.fromEntries(ids.entries()) : [],
          },
        },
      });
    },
    removeObiettivo(id) {
      if (this.onlyAssociaSlot || this.readonly || this.fuoriLimite) {
        return;
      }
      this.updateObiettivi(
        this.obiettiviIds.filter((obiettivoId) => obiettivoId != id)
      );
    },
    overrideAssociaClickCb() {
      if (this.readonly || this.fuoriLimite) return;
      this.overrideAssociaClick(this.ruolo_abc, this.iSlot);
    },
    async disassocia() {
      if (
        this.onlyAssociaSlot ||
        this.readonly ||
        !this.associato ||
        this.disassociando
      ) {
        return;
      }
      this.associatoDaDisassociare = this.associato;
      this.nonMostrareDisassocia = false;
      try {
        if (localStorage.getItem(Constants.LS_HIDE_PLAN_DISASSOCIA_HINT) !== "1") {
          this.dialogDisassocia = true;
          return;
        }
        await this.confermaDisassocia();
      } catch (error) {
        this.errorToast("Errore", "Impossibile scollegare il calciatore dallo slot.");
      }
    },
    async confermaDisassocia() {
      if (this.disassociando) return;
      if (
        this.onlyAssociaSlot ||
        this.readonly ||
        !this.associatoDaDisassociare ||
        this.associato !== this.associatoDaDisassociare
      ) {
        this.dialogDisassocia = false;
        return;
      }
      this.disassociando = true;
      try {
        if (this.nonMostrareDisassocia) {
          localStorage.setItem(Constants.LS_HIDE_PLAN_DISASSOCIA_HINT, "1");
        }
        await db.setPlanAssociato(this.ruolo_abc, this.iSlot, "");
        this.dialogDisassocia = false;
      } catch (error) {
        this.errorToast("Errore", "Impossibile scollegare il calciatore dallo slot.");
      } finally {
        this.disassociando = false;
      }
    },
    showNumpad() {
      if (this.onlyAssociaSlot || this.readonly || this.fuoriLimite) return;
      db.emit("AstaPlanNumpad", this.pCrediti, this.ruolo_abc, this.iSlot);
    },
  },
  computed: {
    slotData() {
      return (this.myPlan[this.ruolo_abc] || {})[this.iSlot] || {
        calciatori: [], crediti: 0, associato: "", fuoriLimite: true,
      };
    },
    fuoriLimite() {
      return !!this.slotData.fuoriLimite;
    },
    ruoliMantraAssociato() {
      const calciatore = this.calciatori[this.associato];
      return calciatore ? calciatore.mantra_ids || [] : [];
    },
    nomeCalciatoreAssociato() {
      if (this.associato && this.calciatori[this.associato]) {
        return this.calciatori[this.associato].calciatore;
      }
      return null;
    },
    pagato() {
      if (this.associato && this.my_squadra.calciatori[this.associato].p) {
        return this.my_squadra.calciatori[this.associato].p;
      }
      return null;
    },
    autocompleteItems() {
      return this.svincolatiPerAutocomplete[this.ruolo_abc];
    },
    obiettiviIds() {
      return Object.values(this.obiettivi || []).filter(
        (id) => id !== null && id !== undefined && id !== ""
      );
    },
    obiettiviDisponibiliIds() {
      return this.autocompleteItems.map((item) => item.value);
    },
    obiettiviVisibili() {
      return this.obiettiviIds
        .filter((id) => this.obiettiviDisponibiliIds.includes(id))
        .filter((id) => this.calciatori[id])
        .map((id) => ({
          id,
          nome: this.calciatori[id].calciatore,
          mantra_ids: this.calciatori[id].mantra_ids || [],
        }));
    },
    obiettivi() {
      return this.slotData.calciatori;
    },
    crediti() {
      return this.slotData.crediti;
    },
    associato() {
      return this.slotData.associato;
    },
    ...Vuex.mapGetters([
      "svincolatiPerAutocomplete",
      "calciatori",
      "acquistiSenzaSlotPerRuolo",
    ]),
    ...Vuex.mapGetters({ myPlan: "myPlanCompleto" }),
  },
  watch: {
    obiettivi: {
      handler(newValue) {
        this.pCalciatori = newValue;
      },
      immediate: true,
    },
    crediti: {
      handler(newValue) {
        this.pCrediti = newValue;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.plan-slot {
  margin: 3px;
  display: flex;
  align-items: stretch;

  .evidenzia {
    animation: pulsante 1.25s infinite;
    box-shadow: 0 0 0 rgb(222 222 222 / 70%);
  }

  &.ruolo_1 .ruolo-pos{
    background-color: var(--ruolo-1);
  }
  &.ruolo_2 .ruolo-pos{
    background-color: var(--ruolo-2);
  }
  &.ruolo_3 .ruolo-pos{
    background-color: var(--ruolo-3);
  }
  &.ruolo_4 .ruolo-pos{
    background-color: var(--ruolo-4);
  }

  .ruolo-pos {
    color: rgb(0 0 0 / 50%);
    display: flex;
    font-weight: bold;
    margin-right: 3px;
    min-width: 23px;
    position: relative;
    border-radius: 2px;
  .ruolo-label {
    align-items: center;
    display: flex;
    font-size: 8px;
    justify-content: start;
    padding-left: 6px;
  }
    .pos {
    position: absolute;
    bottom: 1px;
    right: 0;
    font-size: 8px;
    text-align: center;
    min-width: 10px;
    }
  }

  .azione-associa {
    &.associato {
      background-color: var(--fp_dark_10) !important;
    }
    &.v-btn--disabled {
      box-shadow: none !important;
    }
    &:not(.v-btn--disabled):hover {
      background-color: var(--fp_dark_5);
    }
  }
  .associato {
    background-color: transparent !important;
  }
  .nomi-calciatori {
    min-width: 0;
    // pianificazione + compatta
    font-size: 10px;
    min-height: 23px;
    border-radius: 0 2px 2px 0;

    background-color: var(--fp_dark_6);
    width: 100%;
    cursor: pointer;
    &.associato {
      font-weight: bold;
      text-transform: uppercase;
      color: white;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 3px;
      cursor: default;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      background-color: var(--fp_dark_10) !important;
    }
    &:not(.disabled):hover {
      background-color: var(--fp_dark_5);
    }
  }
  .plan-player-info {
    display: flex;
    flex-direction: row;
    min-width: 0;
    gap: 2px;
    align-items: center;
    flex-wrap: wrap;
  }
  .associato-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .plan-mantra-roles {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
  }
  .obiettivi-calciatori {
    align-items: center;
    display: flex;
    padding: 2px 0 1px 3px;

    &.disabled {
      cursor: default;
      opacity: 0.65;
    }
  }
  .obiettivi-list {
    align-content: flex-start;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 2px;
    min-width: 0;
    overflow: hidden;
  }
  .obiettivi-placeholder {
    align-items: center;
    color: var(--v-navy-lighten1);
    display: flex;
    min-height: 14px;
    padding-left: 4px;
  }
  .obiettivo-chip {
    align-items: center;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 2px;
    color: white;
    display: inline-flex;
    font-size: 8px;
    font-weight: bold;
    height: 15px;
    line-height: 1;
    max-width: 86px;
    min-width: 0;
    padding-left: 4px;
    text-transform: uppercase;
    &.has-mantra {
      height: auto;
      max-width: 100%;
      // padding-top: 3px;
      // padding-bottom: 3px;
    }

  }
      .ruolo-mantra{
    font-size: 7px;
    padding: 0px 1px;
    }
  .obiettivo-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .obiettivo-remove {
    color: var(--v-navy-lighten3);
    height: 14px;
    margin-left: 1px;
    width: 14px;
  }
  .crediti-pianificati {
    margin-left: 3px; // pianificazione + compatta
    font-size: 11px;
    color: white;
    font-weight: bold;
    background-color: var(--fp_dark_6);
    font-family: "Roboto", "Lato";
    max-width: 38px;
    width: 38px;
    min-width: 38px;
    height: auto;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px; // pianificazione + compatta

    .crediti{
      padding-left: 5px;
      padding-right: 5px;
    }
    &.associato {
      background-color: var(--fp_dark_10) !important;
    }
    &.v-btn--disabled {
      color: white !important;
    }

    &:hover {
      background-color: var(--fp_dark_5);
    }
  }
  &.borderAsRuolo {
    border-left-width: 4px;
    border-left-style: solid;
    border-radius: 0;
    &.ruolo_1 {
      border-color: var(--ruolo-1);
    }
    &.ruolo_2 {
      border-color: var(--ruolo-2);
    }
    &.ruolo_3 {
      border-color: var(--ruolo-3);
    }
    &.ruolo_4 {
      border-color: var(--ruolo-4);
    }
  }
}

.new-plan {
  max-width: 38px;
  width: 38px;
  min-width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-radius: 2px;
  font-size: 13px;
  color: white;
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.12);
  font-family: "Roboto", "Lato";
}
</style>
